import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useAnalytics } from 'use-analytics';
import HomeAgent from '../components/Home/Agent';
import HomeCustomer from '../components/Home/Customer';
import { UserRolePermissions } from '../constants';

import ProtectRoute from '../HOCs/protectAuth';
import { checkSitePermission } from '../store/slices/user';
import { VgsIFrameInputProvider } from '../components/CruiseBooking/PaymentConfig/AddCardForm/VgsIFrameInputProvider';
import PageLayout from '../layouts/PageLayout';

const HomePage = () => {
  const { page } = useAnalytics();
  const { isLoggedIn, travelAgency } = useSelector((store) => store.user);
  const canViewPages = useSelector(checkSitePermission(UserRolePermissions.canViewPages));
  const doShowCustomHomePageWhenLoggedIn = travelAgency && travelAgency.settings
  && travelAgency.settings.doShowCustomHomePageWhenLoggedIn;

  useEffect(() => {
    page();
  }, [page]);

  return (
    <PageLayout>
      <ProtectRoute
        doContinueWithoutLogin={canViewPages}
        doPasswordProtectPage
      >
        <VgsIFrameInputProvider>
          {isLoggedIn && !doShowCustomHomePageWhenLoggedIn ? <HomeAgent /> : <HomeCustomer />}
        </VgsIFrameInputProvider>
      </ProtectRoute>
    </PageLayout>
  );
};
export default HomePage;
